module.exports = __webpack_public_path__ + "static/img/sq.97923aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/sq.jpg
// module id = 3wqG
// module chunks = 21